<template>
  <div class="login flex align-center justify-center" @touchmove.prevent   @scroll.stop.prevent>
    <div class="login-main flex-column justify-space-between">
      <div class="flex justify-end p-10">
        <img src="/images/guanbi.png" alt="" @click="onClose" class="cursor">
      </div>
      <div class="flex-column align-center justify-center mb-10">
        12121
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data () {
    return {
      username:'',
      password: ''
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    onClose () {
      
    },
  }
};
</script>

<style lang="scss" scoped>
  .login{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
  }
  .login-main{
    width: 1105px;
    height: 478px;
    background: #fff;
    border-radius: 4px;
  }
  .w-305{
    width: 305px;
  }
  .border-b{
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 6px;
  }
  .line{
    width: 1px;
    height: 18px;
    background: #e9e9e9;
    margin: 0 12px;
  }
  .shadow {
    border-radius: 30px;
    box-shadow: 0px 0px 30px 0px 
		rgba(41, 42, 46, 0.07);
  }
  ::v-deep{
    .el-input__inner{
      border: 0;
      background: transparent;
      font-size: 16px;
      padding: 0;
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus{
      border: 0;
    }
  }
</style>
